import { deleteUserInvite } from "../../api/userInviteService";

export const useDeleteUserInvite = (successCallback) => {
    const remove = async (id) => {
        try {
        await deleteUserInvite(id);
            if (successCallback) successCallback();
        } catch (error) {
            console.error("Failed to delete user invite:", error);
            throw error;
        }
    };

    return { remove };
};